import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface PageIndicatorProps {
  color: string;
}

export default styled.h6<PageIndicatorProps>`
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: ${({ color }) => color};

  @media screen and (min-width: ${DESKTOP}px) {
    font-size: 18px;
  }
`;
